const rates = {
  forms: {
    information: {
      details: {
        fields: {
          supplierId: {
            name: 'Fleets',
          },
        },
      },
    },
  },
};

export default rates;
